import { useLazyQuery } from '@apollo/client';
import React from 'react';
import { LabelFragment } from '../../../../../../../gen-src/queries';
import { UseLabelsResult, UseLabelsResultWithExecuteFunction } from '../useRenderLabelsTypes';
import { GetContentLineageLabelsLazyQueryParams, convertLabelsFragmentIntoRenderProps } from './lazyQueryHelper';

type BaseQueryType = {
  items: Array<({
    upstreamLabels: LabelFragment[]
  })>
}

export function useGeneralLineageLabelsLazyQuery<QueryType extends BaseQueryType>({ item, controls, includeParented, includeUpstream, document }: GetContentLineageLabelsLazyQueryParams): UseLabelsResultWithExecuteFunction {
  const [fire, { loading, error, data }] = useLazyQuery<QueryType>(document);
  const invoke = React.useCallback(() => { void fire({ variables: { luid: item.contentLuid ?? null, id: item.contentId ?? null } }) }, [fire, item]);

  const upstreamLabels = data?.items[0] ? data?.items[0].upstreamLabels : undefined;
  const result: UseLabelsResult = { loading, error, ...convertLabelsFragmentIntoRenderProps({ upstreamLabels, item, controls, includeParented, includeUpstream }) };
  return [invoke, result]
}
